import alertBubble from '@zr/common/js/alertBubble';
import { initEmailPopover } from '../_email-popover';
import initLineChart from './_line-chart';
import './_auto-complete-location';

let activeTab = '';

const hashToNum = {
  '#Yearly': 0,
  '#Monthly': 1,
  '#Weekly': 2,
  '#Hourly': 3,
  '#TableView': 4,
};

const numToHash = {
  0: '#Yearly',
  1: '#Monthly',
  2: '#Weekly',
  3: '#Hourly',
  4: '#TableView',
};

const removeHash = () => {
  window.history.pushState('', document.title, window.location.pathname + window.location.search);
};

const isLocationTemplate = window.location.pathname.startsWith('/Salaries/-in-') || window.location.pathname.startsWith('/Salaries/--in-');

const initSalaryComparison = () => {
  const baseSelector = '.salary_by_location_container ';
  const locationSelector = `${baseSelector}input[type=text]`;
  const addLocationSelector = `${baseSelector}input[type=button]`;
  let locations = [];

  $(addLocationSelector).click(() => {
    const autocompleteValue = $(locationSelector).val();
    if (autocompleteValue !== '' && !locations.includes(autocompleteValue) && $('.invalidInput').is(':hidden')) {
      const url = $(addLocationSelector).data('url').replace('__term__', autocompleteValue).replace(/\s/g, '-');
      $.get(url, (json, status) => {
        if (status !== 'success') {
          alertBubble('There was an error adding location to salary comparison widget.');
          // $.log_event('error', { message: 'failed adding location to salary comparison widget'});
          return;
        }
        locations.push(autocompleteValue);
        const display0 = activeTab === '0' ? 'block' : 'none';
        const display1 = activeTab === '1' ? 'block' : 'none';
        const display2 = activeTab === '2' ? 'block' : 'none';
        const display3 = activeTab === '3' ? 'block' : 'none';
        const newBar = `<div data-salary="${json.salary_year_raw}" class="location-bar" style="width:0%;">`
          + '<div>'
          + `<div>${autocompleteValue}</div>`
          + '<div></div>'
          + '</div>'
          + '<div>'
          + `<div data-comparison="0" style="display:${display0}">${json.salary_year}</div>`
          + `<div data-comparison="1" style="display:${display1}">${json.salary_month}</div>`
          + `<div data-comparison="2" style="display:${display2}">${json.salary_week}</div>`
          + `<div data-comparison="3" style="display:${display3}">${json.salary_hour}</div>`
          + '</div>'
          + '<div class="close">×</div>'
          + '</div>';

        $(newBar).insertBefore(`${baseSelector}.locations-bar .form`);
        const locationBars = $('.location-bar');
        const locationBarsCount = locationBars.length;
        let max = 0.0;
        for (let i = 0; i < locationBarsCount; i++) {
          const salary = parseFloat(locationBars[i].dataset.salary);
          if (salary > max) {
            max = salary;
          }
        }
        for (let i = 0; i < locationBarsCount; i++) {
          const salary = parseFloat(locationBars[i].dataset.salary);
          locationBars[i].style.width = `${salary / max * 100.0}%`;
        }
        if (isLocationTemplate) {
          $('[data-comparison]').hide();
          $(`[data-comparison="${hashToNum[window.location.hash || '#Yearly']}"]`).show();
          $(locationSelector).val('');
        }
      })
        .fail(() => {
          alertBubble('There was an error adding location to salary comparison widget.');
          // $.log_event('error', { message: 'failed adding location to salary comparison widget'});
        });
    }
  });

  $(baseSelector).on('click', '.location-bar .close', function removeLocationBar() {
    $(this).parent().remove();
    $(locationSelector).val('');
    locations = [];
  });

  $(locationSelector).keypress((e) => {
    const key = e.which;
    if (key === 13) { // the enter key code
      $(addLocationSelector).click();
      return false;
    }
    return e;
  });
};

const $salaryNav = $('[data-type="salaryNav"]');
const $navButtons = $salaryNav.find('[data-tab]');
const $mobileMenu = $salaryNav.find('[data-tab="mobileMenu"]');
const $tableViewBtn = $salaryNav.find('[data-tab="tableView"]');
const $tableWrapper = $('[data-national]');

const applyTableView = () => {
  // nav buttons
  $navButtons.removeClass('active');
  $mobileMenu.removeClass('active');
  $('#tableView').addClass('active');
  // hide histogram
  $('[data-histogram]').hide();
  $salaryNav.removeClass('mobile_open');

  $('.salary_comparison_wrapper').hide();

  $tableWrapper.show();
};

const initTabbing = () => {
  let locationHash = window.location.hash;
  activeTab = $('#hiddenQNum')[0].value;

  if (locationHash !== '' && locationHash in hashToNum && window.zr.page.model.isMobile) {
    $('.mobile_menu.active').html(locationHash.substring(1, locationHash.length));
  } else if (locationHash !== '' && locationHash in hashToNum) {
    $('#Hourly').removeClass('active');
  }

  if (locationHash === '' || !(locationHash in hashToNum)) {
    locationHash = numToHash[activeTab];
  }
  if (locationHash === '#TableView') {
    applyTableView();
  }

  if (window.location.pathname.includes('-per-')) {
    locationHash = numToHash[activeTab];
  }

  if (locationHash !== '#Yearly') {
    document.querySelectorAll(`a[href*='${locationHash}']`)[0].lastChild.className = 'active';
  } else {
    $('#Yearly').addClass('active');
  }
  $('[data-comparison]').hide();
  $(`[data-histogram="${hashToNum[locationHash]}"]`).show();
  $(`[data-comparison="${hashToNum[locationHash]}"]`).show();

  $navButtons.on('click', function selectTab() {
    const newTab = $(this).data('tab');
    const tabText = $(this).text();

    if (tabText === 'Yearly') {
      removeHash();
    }
    // do nothing when clicking on same tab
    // preventing change in mobile
    if (newTab === activeTab) {
      return;
    }
    activeTab = newTab;

    $salaryNav.toggleClass('mobile_open');

    // ignore mobileMenu button clicked
    if (newTab === 'mobileMenu' || activeTab === 'tableView') {
      return;
    }

    // nav buttons
    $navButtons.removeClass('active');
    $navButtons.removeAttr('aria-current');
    $tableViewBtn.removeClass('active');
    $(this).addClass('active');
    $(this).attr('aria-current', 'page');

    // update mobile menu button
    $mobileMenu
      .addClass('active')
      .text(tabText);

    // histogram
    $('[data-histogram]').hide();
    $(`[data-histogram="${newTab}"]`).show();

    // comparison by location
    $('[data-comparison]').hide();
    if (isLocationTemplate) {
      $(`[data-comparison="${hashToNum[`#${tabText}`]}"]`).show();
    } else {
      $(`[data-comparison="${newTab}"]`).show();
    }

    // hide national table
    $tableWrapper.hide();
    $('.salary_comparison_wrapper').show();

    // set national table view type
    $tableWrapper.attr('data-national', tabText);
  });

  $tableViewBtn.on('click', () => {
    applyTableView();
  });
};

$(() => {
  if (window.location.hash === '#TableView' && isLocationTemplate) {
    applyTableView();
  }
  initSalaryComparison();
  initTabbing();

  if (window.zr.page.model.chartData) {
    initLineChart('#salary_trend_line_chart_graph_only', window.zr.page.model.chartData);
  }
  if (window.zr.page.model.chartData2) {
    initLineChart('#salary_trend_line_chart_graph_only2', window.zr.page.model.chartData2);
  }
});

initEmailPopover();
// Set modal params.
if ($.modal) {
  $.modal.wait = 0;
  $.modal.zrsCloseBtn = true;
}
